import { isEmpty } from 'ramda';

import { Leaves } from '@speeki/frontend-utils';
import { Palette } from '@speeki/theme';

import { breakpoints } from '@shared/constants';

export const getDialCodeAndPhone = (prefixedPhoneNumber?: string | null) => {
    const [countryCode, phoneNumber] =
        prefixedPhoneNumber && /\s/.test(prefixedPhoneNumber)
            ? prefixedPhoneNumber.split(' ')
            : [null, prefixedPhoneNumber];

    return [countryCode, phoneNumber];
};

export const isArrayEmpty = (array?: unknown[] | null) =>
    !Array.isArray(array) || (Array.isArray(array) && isEmpty(array));

export const maxWidth = (breakpoint: keyof typeof breakpoints) =>
    `@media (max-width: ${breakpoints[breakpoint]}px)`;

export const checkIfTeams = (): boolean => {
    return !!(
        (window.parent === window.self &&
            // TODO: REPAIR ANY TYPE
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (window as any).nativeInterface) ||
        window.name === 'embedded-page-container' ||
        window.name === 'extension-tab-frame'
    );
};

const NON_BREAKING_SPACE_PATTERN = /&nbsp;|\u00a0/gi;

/**
 * Tenant rich-text content (home page / company policies) is frequently pasted
 * from Word / Google Docs / PDF, which stores every inter-word gap as a
 * non-breaking space (`&nbsp;` / U+00A0). Browsers cannot wrap a line at a
 * non-breaking space, so long prose either overflows its column or — with the
 * `overflow-wrap: anywhere` the column relies on (see SPDW-75) — breaks
 * mid-word. Normalising them to regular spaces lets the text wrap naturally at
 * word boundaries. Applied to all tenant-authored rich-text before render.
 */
export const normalizeRichTextWhitespace = (html?: string | null): string =>
    (html ?? '').replace(NON_BREAKING_SPACE_PATTERN, ' ');

export const getPaletteColor = (
    palette: Palette,
    colorPath: Leaves<Palette>,
): string | undefined => {
    const keys = colorPath.split('.');
    let result: Record<string, unknown> = palette;

    for (const key of keys) {
        const value = result[key];

        if (typeof value === 'string') return value;

        result = value as Record<string, unknown>;
    }
};
